var _rect, _g, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b22234"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 24,
    height: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 7,
    fill: "#3c3b6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3.2,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 3.2,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3.2,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3.2,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 4.9,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4.9,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4.9,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.9,
    r: 0.35
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.cab34d3b227fe9689b17d89ab0f1a961.svg";
export { ForwardRef as ReactComponent };